import { render, staticRenderFns } from "./FiltrosLeads.vue?vue&type=template&id=1b37e721"
import script from "./FiltrosLeads.vue?vue&type=script&lang=js"
export * from "./FiltrosLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports